/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module HealthScoreModule
 */

import {
    Pipe,
    PipeTransform,
} from '@angular/core';

import { OperationalState } from 'generated-types';

/**
 * @description
 * Pipe that transforms an OperationalState enum value to a Clarity icon status string.
 * @author alextsg
 */
@Pipe({
    name: 'operationalStateIconStatus',
})
export class OperationalStateIconStatusPipe implements PipeTransform {
    // eslint-disable-next-line class-methods-use-this
    public transform(operationalState: OperationalState): 'success' | 'danger' | '' {
        switch (operationalState) {
            case OperationalState.OPER_UP:
            case OperationalState.OPER_DISABLING:
            case OperationalState.OPER_ERROR_DISABLED:
                return 'success';

            case OperationalState.OPER_DISABLED:
            case OperationalState.OPER_INACTIVE:
            case OperationalState.OPER_UNUSED:
                return '';

            default:
                return 'danger';
        }
    }
}
